import React from 'react';
import Box from '@mui/material/Box';
import InputBase from '@mui/material/InputBase';
import Typography from '@mui/material/Typography';
import LinkIcon from '@mui/icons-material/Link';
import { monoSx } from '../dashboard/styles';
import { isHttpUrl } from './mappingScope';

interface SwaggerUrlFieldProps {
  value: string;
  onChange: (value: string) => void;
}

const SwaggerUrlField: React.FC<SwaggerUrlFieldProps> = ({ value, onChange }) => {
  const invalid = !!value.trim() && !isHttpUrl(value);
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.25,
          height: 48,
          px: 1.75,
          borderRadius: 2.5,
          border: 1,
          borderColor: invalid ? 'error.main' : 'divider',
          bgcolor: 'background.paper',
          '&:focus-within': { borderColor: invalid ? 'error.main' : 'primary.dark' },
        }}
      >
        <LinkIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
        <InputBase
          fullWidth
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="https://api.example.com/openapi.json"
          inputProps={{ 'aria-label': 'Swagger/OpenAPI URL', 'aria-invalid': invalid }}
          sx={{ ...monoSx, fontSize: 13 }}
        />
      </Box>
      <Typography sx={{ fontSize: 12, color: invalid ? 'error.main' : 'text.secondary' }}>
        {invalid ? 'Enter a full URL starting with https://' : 'Link to a .json OpenAPI/Swagger spec. It is fetched when the document is generated.'}
      </Typography>
    </Box>
  );
};

export default SwaggerUrlField;
